import {Component, OnInit} from '@angular/core';
import {PasswordType, SignInForm, UserNameType} from "@mpt-fo/common/shared/models/utility.model";
import {CustomInput, PhoneNumberInput} from "@mpt-fo/common/kamona/components/kamona-input-field/kamona-input-field.component";
import {FormBuilder, FormGroup} from "@angular/forms";
import {AuthenticationService} from "@mpt-fo/common/core/services/authentication.service";
import {StringHelper} from "@mpt-fo/common/core/helpers/strings.helper";
import {ProfileSetupService} from "@mpt-fo/common/core/services/profile-setup/profile-setup.service";
import {LoginHelperService} from "@mpt-fo/common/core/services/login-helper.service";
import {DeviceHelperService} from "@mpt-fo/common/core/services/device-helper.service";
import {LoginRequestModel} from "@mpt-fo/common/shared/models/login.model";
import {
	KamonaProgressModalComponent
} from "@mpt-fo/common/kamona/components/kamona-progress-modal/kamona-progress-modal.component";
import {ModalOptionsConfig, ModalService} from "@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service";
import {HIDE_ANT_MODAL_CLASS} from "@mpt-fo/common/shared/constants";
import {NzModalRef} from "ng-zorro-antd/modal";
import {ErrorCode} from "@app/channels/onboarding/onboarding-v2/model/onboarding-v2-model";
import {BtnType, ModalType} from "@mpt-fo/common/kamona/model/kamonal-model";
import { AccountsClosedModalComponent } from '@mpt-fo/common/lean-shared/components/accounts-closed-modal/accounts-closed-modal.component';

@Component({
  selector: 'app-sign-in-form',
  templateUrl: './sign-in-form.component.html',
  styleUrls: ['./sign-in-form.component.scss']
})
export class SignInFormComponent implements OnInit {
    loadingLoginType: boolean;
	currentForm: SignInForm;
	SignInForm = SignInForm;
	readonly UserNameType = UserNameType;
	usernameType: UserNameType = UserNameType.PHONENUMBER;
	phoneNumber: PhoneNumberInput;
	username: CustomInput;
	passwordType = PasswordType.PASSCODE;
	readonly PasswordType = PasswordType;
	phoneNumberForm:FormGroup;
	usernameForm:FormGroup;
	password: string;
	passcode: string;
	readonly defaultTitle = 'Login to your account';
	readonly defaultSubTitle = 'Just enter the required credentials below';
	readonly passcodeFormTitle = 'Enter Passcode';
	readonly passcodeFormSubTitle = 'Enter your 6 digit passcode';
	readonly passwordFormTitle = 'Enter Password';
	readonly passwordFormSubTitle = 'Enter your password';
	readonly SubmittingDescription = 'Logging in....';
	readonly NETWORK_ERROR = 'Please make sure you have internet connectivity';
	title = this.defaultTitle;
	subTitle = this.defaultSubTitle;
	runningModal: NzModalRef;
	error: any;
	isUserSuspended: boolean;
	suspendedDescription: string;
	suspendedTitle: string;
	suspensionReleaseTimeEpoch: any;
	iconType;
	btnText;
	btnType;
	nzSelectedIndex: number;
	maskPhoneNumber: string;
	ModalType = ModalType;
	showDeviceRegistrationModal: boolean;
  constructor(
	  private fb: FormBuilder,
	  private auth: AuthenticationService,
	  private profileService: ProfileSetupService,
	  private loginHelper: LoginHelperService,
	  private deviceHelper: DeviceHelperService,
	  private modalService: ModalService) { }

  ngOnInit(): void {
  }

  buildForm(){
	  this.buildPhoneNumberForm();
	  this.buildUsernameForm();
  }

  buildPhoneNumberForm(){
	  this.phoneNumber = new PhoneNumberInput( null, 'Phone Number', true);
	  this.phoneNumberForm = this.fb.group({
		  phoneNumber: this.phoneNumber.getFormGroupControl()
	  });
  }

  setCurrentTab($event){
	this.nzSelectedIndex = $event;
	this.usernameType = $event ? UserNameType.USERNAME : UserNameType.PHONENUMBER;
 }

  buildUsernameForm(){
	  this.username = new CustomInput( null, 'Username', true);
	  this.usernameForm = this.fb.group({
		  username: this.username.getFormGroupControl()
	  })
  }

	setPassword($event){
	  this.password = $event;
	}

	setPasscode($event){
	  this.passcode = $event;
	}

	getLoginType(){
	  this.loadingLoginType = true;
	  const payload = this.buildLoginTypePayload();
	  this.auth.loginGetUserType(payload)
	  .then(res => {
		  this.profileService.saveUserTypePayload(payload);
		  this.handleLoginTypeResponse(res);
	  })
	  .catch(error => {
		 this.handleLoginTypeError(error);
	  }).finally(() => this.loadingLoginType = false);
	}

	handleLoginTypeResponse(res){
		this.setPasswordType(res);
		this.setMaskPhoneNumber();
	     this.setPasswordFormParameters();
		this.currentForm = SignInForm.PASSWORD;
	}

	setMaskPhoneNumber(){
	  const form = this.phoneNumberForm?.value;
	  const phoneNumber = form?.phoneNumber;
	  if(!phoneNumber){return;}
	  const NO_OF_CHARACTERS = 4;
	  this.maskPhoneNumber = StringHelper.maskMobilePhoneNumber(phoneNumber, NO_OF_CHARACTERS);
	}

	setPasswordType(res){
	  this.passwordType = PasswordType.PASSCODE;
	  const loginType: string = res?.loginType?.toLowerCase();
	  const isPasswordType = loginType === 'password';
	  if(isPasswordType){
		  this.passwordType = PasswordType.PASSWORD;
	  }
	}

	handleLoginTypeError(error){
	  const description = StringHelper.getErrorMessageHttpErrorResponse(error);
	  this.profileService.handleErrorModal({description})
	}

	buildLoginTypePayload(){
	  const identityType = this.usernameType;
	  const value = this.usernameType === UserNameType.PHONENUMBER ?
	  this.phoneNumberForm?.value?.phoneNumber : this.usernameForm?.value?.username;
	  return {identityType, value}
	}

	setPasswordFormParameters(){
	  const isPasscodeType = this.passwordType === PasswordType.PASSCODE;
	  this.title = isPasscodeType ? this.passcodeFormTitle : this.passwordFormTitle;
	  this.subTitle = isPasscodeType ? this.passcodeFormSubTitle : this.passwordFormSubTitle;
	}

	setUsernameFormParameters(){
		this.title = this.defaultTitle;
		this.subTitle = this.defaultSubTitle;
	}


	buildSignInPayload(): LoginRequestModel{
	  const deviceInformation = this.getDeviceInformation();
		return {
			 deviceUniqueIdentifier: deviceInformation?.deviceUniqueIdentifier,
			 manufacturer: deviceInformation?.manufacturer,
			 model: deviceInformation?.model
		}
	}

	getDeviceInformation() {
		return this.deviceHelper.getDeviceInformation();
	}

	buildPasscodePayload(): LoginRequestModel{
	  const payload = this.buildSignInPayload();
	  const loginType = PasswordType.PASSCODE;
	  const passcode = this.passcode;
	  return {...payload, loginType, passcode, ...this.getLoginUsername()};
	}

	buildPasswordPayload(){
		const payload = this.buildSignInPayload();
		const loginType = PasswordType.PASSWORD;
		const password = this.password;
		return {...payload, loginType, password, ...this.getLoginUsername()};
	}

	getLoginUsername(): any{
	  const isPhoneNumber = this.usernameType === UserNameType.PHONENUMBER;
	  const phoneNumber = this.phoneNumberForm?.value?.phoneNumber;
	  const username = this.usernameForm?.value?.username;
	  return isPhoneNumber ? {phoneNumber} : {username};
	}

	getLoginPassword(): any{
		const isPasscode = this.passwordType === PasswordType.PASSCODE;
		const passcode = this.passcode;
		const password = this.password;
		return isPasscode ? passcode : password;
	}

	handleSignIn(){
	  const payload = this.getSignInPayload();
	  this.openInProgressModal();
	  this.signIn(payload)
		 .catch(error => {
			this.handleFailedSignIn(error);
	     })
	}

	closeProgressModal(){
	  this.modalService.closeAll();
	}

	getSignInPayload(){
		const isPasswordType =  this.passwordType === PasswordType.PASSWORD;
		return  isPasswordType ? this.buildPasswordPayload()
		: this.buildPasscodePayload();
	}

	errorList(){
	  const map = new Map<string, () => void>();
	  map.set(ErrorCode.LIVELINESS_REQUIRED, this.handleDeviceRegistration);
	  map.set(ErrorCode.DEVICE_REGISTRATION, this.handleDeviceRegistration);
	  map.set(ErrorCode.OTP_SUSPENSION, this.handleSuspension);
	  map.set(ErrorCode.OTP_SUSPENSION_V2, this.handleSuspension);
	  map.set(ErrorCode.ALL_BUSINESSES_CLOSED, this.handleAllBusinessClosed);
	  map.set(ErrorCode.STAFF_USER_LOGIN, this.handleStaffUserLogin);
	  map.set(ErrorCode.CLUSTER_MANAGER_USER_LOGIN, this.handleClusterManagerUserLogin)
	  return map;
	}

	findErrorFunctionByErrorCode(code: string){
	  const errors = this.errorList();
	  let error = errors.get(code);
	  if(!error){
		error = this.handleErrorCodeNotFound();
	  }
	  return error;
	}

	handleErrorCodeNotFound(){
		const isNetworkError = !window?.navigator?.onLine;
		return isNetworkError ? this.handleNetworkError : this.handleError;
	}

	handleError = () => {
	  const description = this.error?.description || this.error?.responseMessage;
	  this.profileService.handleErrorModal({description});
	}

	handleDeviceRegistration = () => {
	  this.setParameterForDeviceRegistration();
	  this.handleDeviceRegistrationModal();
	}

	setParameterForDeviceRegistration(){
	  const payload = this.buildPayloadForDeviceRegistration();
	  this.updateDeviceRegistrationPayloadWithLoginCredentials(payload);
	  payload.maskedPhoneNumber = this.getMaskedPhoneNumber();
      this.profileService.saveSignInResponse(payload);
	}

	updateDeviceRegistrationPayloadWithLoginCredentials(payload: any){
		const isPhoneNumber = this.usernameType === UserNameType.PHONENUMBER;
		payload.username = isPhoneNumber ? this.getLoginUsername()?.phoneNumber : this.getLoginUsername()?.username;
		payload.password = this.getLoginPassword();
	}

	getMaskedPhoneNumber(){
	    const message = this.error?.message;
		const maskPhoneNumber = message?.split(" ")?.pop();
		if(StringHelper.hasNumber(maskPhoneNumber))
		return maskPhoneNumber;
		const phoneNumber = this.error?.tokenData?.phone || this.error?.identifier;
		return `*****${StringHelper.maskMobilePhoneNumber(phoneNumber, 3)}`;
	}

	buildPayloadForDeviceRegistration(): any {
		const identifier = this.error?.identifier;
		const ussdCode = this.error?.ussdCode;
		const reference = this.error?.reference;
		const loginType = this.passwordType;
		const userNameType = this.usernameType;
		const flowId = this.error?.flowId;
		return {identifier, ussdCode, loginType, userNameType, reference, provider: this.error?.provider, flowId};
	}

	handleSuspension = () => {
		this.closeDeviceRegistrationModal();
		this.setUserSuspensionParameters();
	}

	handleAllBusinessClosed = () => {
		if (this.loginHelper.isStaffUserRefreshTokenEnabled() && this.error?.code === ErrorCode.ALL_BUSINESSES_CLOSED) {
			this.openAccountsClosedModal();
			return;
		}
	}

	handleStaffUserLogin = () => {
		if (this.loginHelper.isStaffUserRefreshTokenEnabled()) {
			return;
		}
	}

	handleClusterManagerUserLogin = () => {
		return;
	}

	openAccountsClosedModal() {
		const config = new ModalOptionsConfig();
		config.nzMaskClosable = false;
		this.runningModal?.destroy();
		this.modalService.createModal(AccountsClosedModalComponent, config);
	}

	handleNetworkError = () =>{
		this.networkErrorEvent();
		this.profileService.handleErrorModal(this.getNetworkErrorParameter());
	}

	getNetworkErrorParameter() {
		return {
			title: 'No Connectivity',
			description: this.NETWORK_ERROR,
		};
	}

	networkErrorEvent() {
	    const event = 'sign_in_failed';
		const isPhoneNumber = this.usernameType === UserNameType.PHONENUMBER;
		const username = isPhoneNumber ? this.getLoginUsername()?.phoneNumber :  this.getLoginUsername()?.username;
		const api_error_message = this.getNetworkErrorParameter()?.description;
		this.profileService.logMixPanelEvent({event, api_error_message, api_error_code: '',  username});
	}

	handleFailedSignIn(error){
	 this.error = error?.error;
		this.error = error?.error;
		const errorCode = this.error?.code || this.error?.responseCode;
		this.loginHelper.saveStaffUserTokenData((this.error?.code === ErrorCode.STAFF_USER_LOGIN ? this.error?.tokenDataDeviceResponse : this.error), this.error?.code === ErrorCode.STAFF_USER_LOGIN);
		this.loginHelper.saveStaffUserTokenData((this.error?.code === ErrorCode.CLUSTER_MANAGER_USER_LOGIN ? this.error?.tokenDataDeviceResponse : this.error), this.error?.code === ErrorCode.CLUSTER_MANAGER_USER_LOGIN);
		const errorFunction = this.findErrorFunctionByErrorCode(errorCode);
		this.closeProgressModal();
		errorFunction();
	}

	async signIn(payload: LoginRequestModel){
	  const res = await this.auth.loginFD(payload);
	  const isPhoneSignInNumberType = this.usernameType === UserNameType.PHONENUMBER;
	  const username = isPhoneSignInNumberType ? payload?.phoneNumber : payload?.username;
	  await this.handleSignInResponse(res, username);
	}

	async handleSignInResponse(res, username) {
		this.handleSignInResponseEvent(res, username);
		const deviceInformation = this.getDeviceInformation();
		this.loginHelper.processSessionUser(res, deviceInformation)
		.finally(() => {this.closeProgressModal()})
	}

	handleSignInResponseEvent(res, username) {
	    const event = 'sign_in_success';
		const email = res?.tokenData?.email;
		const sign_in_mode = `${this.usernameType} and ${this.passwordType}`;
		const business_owner_first_name = res?.tokenData?.firstName;
	    const signInSuccessParameters = {event, user_name: username, email, business_owner_first_name, sign_in_mode};
	    this.profileService.logMixPanelEvent(signInSuccessParameters);
		const identityUserParameters = {event:'identify_user',user_name: username, email, business_owner_first_name, sign_in_mode};
		this.profileService.logMixPanelEvent(identityUserParameters);
	}

	openInProgressModal() {
	    const description = this.SubmittingDescription;
		const config = this.createConfig(description);
		this.runningModal = this.modalService.createModal(KamonaProgressModalComponent, config);
	}

	createConfig(description) {
		const config = new ModalOptionsConfig();
		config.nzMaskClosable = false;
		config.nzComponentParams.data = {description, useExtraDescription: false};
		config.className = HIDE_ANT_MODAL_CLASS;
		return config;
	}

	goBack(){
	  this.setUsernameFormParameters();
	  this.currentForm = SignInForm.USERNAME;
	}


	registerDevice(){
	  this.profileService.routeToDeviceRegistration();
	  this.closeDeviceRegistrationModal();
	}

	setUserSuspension(isSuspended){
	  this.isUserSuspended = isSuspended;
	}

	setUserSuspensionParameters(){
		this.suspendedTitle = 'Too Many Failed Attempts';
		this.suspendedDescription = this.error?.responseMessage;
		this.btnType = BtnType.SECONDARY;
		this.btnText = 'Dismiss';
		this.suspensionReleaseTimeEpoch  = this.error?.suspensionReleaseTimeEpoch ?? new Date(this.error?.suspensionReleaseTime)?.getTime();
		this.setUserSuspension(true);
	}

	closeUserSuspensionModal(){
	  this.setUserSuspension(false);
	}

	handleDeviceRegistrationModal(){
		this.setDeviceRegistrationModal(true);
	}

	setDeviceRegistrationModal(isModal: boolean){
		this.showDeviceRegistrationModal = isModal;
	}

	closeDeviceRegistrationModal(){
		this.setDeviceRegistrationModal(false);
	}

	handleForgotCredentials(){
	  const isPasscode = this.passwordType === PasswordType.PASSCODE;
	  isPasscode ? this.profileService.forgotPasscode() : this.profileService.forgotPassword();
	}

	forgotUsername(){
	 this.profileService.forgotUsername();
	}


}
